import { Checkbox, HStack, Link, Text } from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa6";
import { useThemeContext } from "../../Context/ThemeContext";
import { useTheme } from "next-themes";

export const TermsAndConditions = ({ isChecked, setIsChecked }) => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];

  return (
    <Checkbox.Root
      checked={isChecked}
      onChange={() => setIsChecked((prev) => !prev)}
    >
      <Checkbox.HiddenInput />
      <HStack alignItems="flex-start">
        <Checkbox.Control
          border="1px solid"
          borderColor={isChecked ? theme.brandPrimary : theme.borderSecondary} 
          margin="5px"
          color={theme.brandPrimary}
        >
          <FaCheck />
        </Checkbox.Control>
        <Checkbox.Label>
          <Text as="span" color={theme.textTertiary} fontWeight="400" fontSize="xs">
            I confirm that I am 18 years or older and consent to Moneyplant Fx
            Ltd processing my personal data to communicate with me for marketing
            and newsletter purposes and that I may unsubscribe from this list at
            any time, as specified in the{" "}
            <Link
              color={theme.textLink}
              _hover={{ color: theme.textLinkHover }}
              href="https://cdn.xxexch247.com/MoneyPlantKYC/money+plant+-+2026+neo.pdf"
              textDecoration="underline"
              rel="noopener noreferrer"
              target="_blank"
              display="inline"
            >
              Privacy Policy
            </Link>
            . By registering for an account, you hereby agree with the{" "}
            <Link
              color={theme.textLink}
              _hover={{ color: theme.textLinkHover }}
              href="https://cdn.xxexch247.com/MoneyPlantKYC/money+plant+-+2026+neo.pdf"
              textDecoration="underline"
              rel="noopener noreferrer"
              target="_blank"
              display="inline"
            >
              Terms and Conditions
            </Link>{" "}
            and the entire content of all legal documents.
          </Text>
        </Checkbox.Label>
      </HStack>
    </Checkbox.Root>
  );
};
